import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    root: {
        width: "100%",
    },
    iframe: {
        width: "100%",
        border: "none",
        display: "block",
    },
}));

export default function IframeEmbed(props) {
    const classes = useStyles();

    const {
        url,
        height,
        width,
        title,
        allow,
        sandbox,
        scrolling,
        style,
    } = props.componentConfig;

    return (
        <div className={classes.root}>
            <iframe
                src={url}
                title={title || "iframe-embed"}
                className={classes.iframe}
                style={{
                    width: width || "100%",
                    height: height || "100%",
                    ...style,
                }}
                allow={allow || ""}
                sandbox={sandbox || undefined}
                scrolling={scrolling || "auto"}
            />
        </div>
    );
}

IframeEmbed.displayName = "IframeEmbed";

export const componentDescription = {
    componentConfig: {
        url: {
            label: "URL del iframe",
            errorMessage: "",
            fieldName: "url",
            type: "text",
            defaultValue: "",
            required: true,
            regex: "",
            textSize: "h6",
        },
        title: {
            label: "Título del iframe",
            errorMessage: "",
            fieldName: "title",
            type: "text",
            defaultValue: "iframe-embed",
            required: false,
            regex: "",
            textSize: "h6",
        },
        height: {
            label: "Alto del iframe",
            errorMessage: "",
            fieldName: "height",
            type: "text",
            defaultValue: "500px",
            required: true,
            regex: "",
            textSize: "h6",
        },
        width: {
            label: "Ancho del iframe",
            errorMessage: "",
            fieldName: "width",
            type: "text",
            defaultValue: "100%",
            required: false,
            regex: "",
            textSize: "h6",
        },
        allow: {
            label: "Permisos del iframe (allow)",
            errorMessage: "",
            fieldName: "allow",
            type: "text",
            defaultValue: "",
            required: false,
            regex: "",
            textSize: "h6",
        },
        sandbox: {
            label: "Sandbox del iframe",
            errorMessage: "",
            fieldName: "sandbox",
            type: "text",
            defaultValue: "",
            required: false,
            regex: "",
            textSize: "h6",
        },
        scrolling: {
            label: "Scrolling",
            errorMessage: "",
            fieldName: "scrolling",
            type: "text",
            defaultValue: "auto",
            required: false,
            regex: "",
            textSize: "h6",
        },
    },
};
